export default {
  methods: {
    /**
     * Muestra mensajes de notificaciones
     * @param message
     * @param alertType (is-white|is-black|is-light|is-dark|is-primary|is-info|is-success|is-warning|is-danger)
     */
    alert(message, alertType = 'is-warning') {
      this.$buefy.notification.open({
        duration: 3000,
        message,
        type: alertType,
        hasIcon: true
      });
    }
  }
};
